import { render, staticRenderFns } from "./KegelNavbar.vue?vue&type=template&id=8fd55abc&"
import script from "./KegelNavbar.vue?vue&type=script&lang=js&"
export * from "./KegelNavbar.vue?vue&type=script&lang=js&"
import style0 from "./KegelNavbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports